// src/components/brandCustomization/PublicPageCustomization/PublicPageCard.jsx
import React from 'react';
import { FaSearch, FaShoppingBag, FaQrcode } from 'react-icons/fa';
import { CustomizationCard, SaveResetButtons } from '../shared';
import PublicPageForm from './PublicPageForm';
import LayoutSelector from './LayoutSelector';

/**
 * PublicPageCard - Card completo para una página pública
 */
const PublicPageCard = ({
    pageName,
    formData,
    onUpdate,
    onToggleActive,
    onSave,
    onReset,
    onPreview,
    isSaving
}) => {
    const pageInfo = {
        findTicket: {
            name: 'Página de Búsqueda de Tarjeta',
            description: 'Permite a los usuarios encontrar su tarjeta por email',
            icon: FaSearch
        },
        productos: {
            name: 'Página de Productos',
            description: 'Catálogo público de productos de la marca',
            icon: FaShoppingBag
        },
        qrRegister: {
            name: 'Página de Registro QR',
            description: 'Formulario de registro para nuevos clientes desde QR',
            icon: FaQrcode
        }
    };

    const info = pageInfo[pageName];
    const pageData = formData || {};

    const handleFieldChange = (field, value) => {
        onUpdate(pageName, field, value);
    };

    return (
        <CustomizationCard
            title={info.name}
            description={info.description}
            icon={info.icon}
            isActive={pageData.isActive}
            onToggleActive={() => onToggleActive(pageName)}
        >
            {/* Selector de Layout */}
            <LayoutSelector
                pageName={pageName}
                selectedLayout={pageData.layout}
                onChange={(layout) => handleFieldChange('layout', layout)}
            />

            {/* Form de textos */}
            <PublicPageForm
                pageName={pageName}
                values={pageData.texts}
                onChange={handleFieldChange}
            />

            {/* Botones de acción */}
            <SaveResetButtons
                onSave={() => onSave(pageName)}
                onReset={() => onReset(pageName)}
                onPreview={onPreview ? () => onPreview(pageName) : undefined}
                isSaving={isSaving[pageName]}
                hasChanges={true}
                previewText="Vista Previa"
            />
        </CustomizationCard>
    );
};

export default PublicPageCard;

